import React from "react";
import "./AboutUs.css";
import { Link } from "react-router-dom";
import SEOHead from "../../common/SEOHead/SEOHead";

function AboutUs() {
  return (
    <div className="about-page">
      <SEOHead
        title="About GoalFlex - Minnesota's AI-Powered Goal Achievement Platform"
        description="Learn about GoalFlex's mission to help people achieve their goals through intelligent planning and tracking. Founded in Minnesota, we're dedicated to transforming how people approach personal and professional growth."
        keywords="about goalflex, Minnesota startup, goal achievement, AI planning, company story, mission, team"
        url="https://goalflex.net/about"
      />
      {/* Hero Section */}
      <section className="about-hero">
        <div className="container">
          <h1>Connecting Soccer Players Across America</h1>
          <p className="hero-subtitle">
            We're building the future of pickup soccer – one game, one player,
            one community at a time.
          </p>
        </div>
      </section>

      {/* Mission Section */}
      <section className="mission-section">
        <div className="container">
          <div className="mission-content">
            <div className="mission-text">
              <h2>Our Mission</h2>
              <p>
                GoalFlex exists to break down barriers in soccer. We believe
                that finding a great game shouldn't be complicated, expensive,
                or exclusive. Our platform connects passionate players with
                quality games, fostering communities where everyone can play,
                improve, and belong.
              </p>
              <p>
                Since our founding, we've facilitated over 2.5 million games and
                helped build lasting friendships that extend far beyond the
                field.
              </p>
            </div>
            <div className="mission-stats">
              <div className="stat">
                <span className="stat-number">500+</span>
                <span className="stat-label">Games Facilitated</span>
              </div>
              <div className="stat">
                <span className="stat-number">500+</span>
                <span className="stat-label">Active Players</span>
              </div>
              <div className="stat">
                <span className="stat-number">Minnesota</span>
                <span className="stat-label">Service Area</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Values Section */}
      <section className="values-section">
        <div className="container">
          <h2 className="section-title">What Drives Us</h2>
          <div className="values-grid">
            <div className="value-card">
              <div className="value-icon">🏆</div>
              <h3>Quality First</h3>
              <p>
                We partner with verified venues and organizers to ensure every
                game meets our high standards for safety, organization, and fun.
              </p>
            </div>
            <div className="value-card">
              <div className="value-icon">🤝</div>
              <h3>Inclusive Community</h3>
              <p>
                Soccer is for everyone. We're committed to creating welcoming
                spaces where players of all backgrounds and skill levels can
                thrive.
              </p>
            </div>
            <div className="value-card">
              <div className="value-icon">⚡</div>
              <h3>Innovation</h3>
              <p>
                We leverage technology to solve real problems, making it easier
                than ever to find, join, and organize pickup soccer games.
              </p>
            </div>
            <div className="value-card">
              <div className="value-icon">🌟</div>
              <h3>Player Experience</h3>
              <p>
                Every feature we build is designed with the player in mind, from
                seamless booking to post-game connections.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Story Section */}
      <section className="story-section">
        <div className="container">
          <div className="story-content">
            <h2>Our Story</h2>
            <div className="story-text">
              <p>
                GoalFlex was born from a simple frustration: finding a good
                pickup soccer game was way too hard. Our founders, lifelong
                soccer players, spent countless hours texting friends, checking
                Facebook groups, and showing up to empty fields.
              </p>
              <p>
                "There had to be a better way," they thought. So in 2024, they
                built one.
              </p>
              <p>
                What started as a simple app for their local community quickly
                grew into something bigger. Players loved the convenience,
                organizers appreciated the tools, and field owners saw increased
                bookings. Today, GoalFlex is the fastest-growing soccer platform
                in North America.
              </p>
              <p>
                But we're just getting started. Our vision is a world where
                every soccer player can find their perfect game, anytime,
                anywhere.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Team Section */}
      <section className="team-section">
        <div className="container">
          <h2 className="section-title">Meet the Team</h2>
          <div className="team-grid">
            <div className="team-member">
              <div className="member-photo"></div>
              <h4>Abdulhakim Sirko</h4>
              <p className="member-role">Co-Founder & CEO</p>
              <p className="member-bio">
                Former D1 player turned tech entrepreneur. Alex leads our vision
                to make soccer accessible to everyone.
              </p>
            </div>
            <div className="team-member">
              <div className="member-photo"></div>
              <h4>Samera Deko</h4>
              <p className="member-role">Co-Founder & CTO</p>
              <p className="member-bio">
                Software engineer and weekend warrior. Samera builds the
                technology that powers our platform.
              </p>
            </div>
            <div className="team-member">
              <div className="member-photo"></div>
              <h4>Marcus Johnson</h4>
              <p className="member-role">Head of Operations</p>
              <p className="member-bio">
                Former coach who understands what makes great soccer communities
                thrive and grow.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="about-cta">
        <div className="container">
          <h2>Ready to Join the Movement?</h2>
          <p>Be part of the community that's revolutionizing pickup soccer.</p>
          <div className="cta-buttons">
            <Link to="/download" className="btn-primary">
              Start Playing
            </Link>
            <Link to="/contact" className="btn-secondary">
              Get in Touch
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}

export default AboutUs;
